
export default function(o,div,id){

  var animation = null
  var speed = 0
  
  var highlightedElement = null

  function isDescendant(parent, child) {
    var node = child.parentNode
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode
    }
    return false
  }

  var highlight = function(targetElement){

    if (highlightedElement === targetElement) {
      return
    }

    if(highlightedElement){
      highlightedElement.classList.add('notHighlighted')
      highlightedElement.classList.remove('highlighted')
    }

    highlightedElement = targetElement

    highlightedElement.classList.remove('notHighlighted')
    highlightedElement.classList.add('highlighted')

    // o.util.soundTick(o)

  }

  var mouseOver = function(e){
    animation = setInterval(function(){

      var divScroll = div[0].scrollLeft
      var maxScroll = Math.ceil(div[0].scrollWidth - $(document).width())
      var newDivScroll = Math.round(divScroll += speed * 4.5)

      if(newDivScroll >= 0 && newDivScroll <= maxScroll){
        div[0].scrollLeft = newDivScroll
      }

      var hoverTarget = 
        document.elementFromPoint(o.currentMouseX, o.currentMouseY)

      if (hoverTarget && isDescendant(div[0], hoverTarget)) {
        highlight(hoverTarget)
      } else if(!(isDescendant(div[0], hoverTarget) || div[0] == hoverTarget)){
        mouseOut()
      }

    }, 10)
  }

  var mouseOut = function(e){
    if(highlightedElement){
      highlightedElement.classList.remove('highlighted')
    }
    clearInterval(animation)
  }

  var mouseMove = function(e){
    var dw = $(document).width()
    speed = (e.pageX - dw / 2) * 2 / dw
  }

  div
  .mousemove(mouseMove)
  .mouseover(mouseOver)
  .mouseout(mouseOut)

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/animateOneLiner/animateOneLiner.js